var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-item-block"},[(_vm.closable)?_c('span',{staticClass:"m-closed",on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }